import {ApiProvider} from "@renta-apps/athenaeum-react-common";
import {SearchType} from "@/models/Enums";
import {ProductGroupName} from "@/models/server/ProductGroupName";
import queryString from "query-string";

export const saveSearchLogAsync = async (searchType: SearchType, id: string): Promise<void> => {
    const body = {searchType, id};
    await ApiProvider.postAsync('/api/SearchLogs/Save', body);
};

export const getMostPopularSearchesAsync = async (searchType: SearchType, limit: number = 5): Promise<ProductGroupName[]> => {
    const query = queryString.stringify({searchType, limit});
    return await ApiProvider.getAsync<ProductGroupName[]>(`/api/SearchLogs/GetMostPopular?${query}`, null);
};